__webpack_require__.p = "/vocab-game/";